var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"fu",staticClass:"callback float",on:{"click":_vm.onClick,"mousedown":_vm.down,"touchstart":_vm.down,"mousemove":_vm.move,"touchmove":_vm.move,"mouseup":_vm.end,"touchend":_vm.end}},[_c('img',{attrs:{"src":require("../../static/images/return.png"),"alt":""},on:{"click":_vm.callback}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e3b2f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/floatBtn.vue
// module id = null
// module chunks = 